import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NotifyForm = ({ track, testid, buttonText = "Notify me", successText = "We'll let you know first. ✦", placeholder = "Email address", dark = false }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error("Please enter your email."); return; }
    setLoading(true);
    try {
      await axios.post(`${API}/waitlist`, { email, track });
      setDone(true);
      toast.success("You're on the list.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  if (done) return <p data-testid={`${testid}-success`} className={`text-sm font-body ${dark ? "text-[#E8B486]" : "text-[#A9724E]"}`}>{successText}</p>;

  return (
    <form onSubmit={submit} data-testid={testid} className="flex flex-col sm:flex-row gap-3 max-w-md">
      <Input
        data-testid={`${testid}-email`}
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={placeholder}
        className={`bg-transparent border-0 border-b rounded-none px-0 h-11 focus-visible:ring-0 focus-visible:border-[#A9724E] ${dark ? "border-[#6B6259] text-[#F4EFE6] placeholder:text-[#9C9186]" : "border-[#D1C9BE]"}`}
      />
      <Button type="submit" disabled={loading} data-testid={`${testid}-submit`} className={`rounded-full px-7 shrink-0 ${dark ? "bg-[#E8B486] hover:bg-[#F0C59D] text-[#2A2825]" : "bg-[#2A2825] hover:bg-[#413d38] text-[#F4EFE6]"}`}>
        {loading ? "…" : buttonText}
      </Button>
    </form>
  );
};
